('./etfLegalConfirmation.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @commons
const { OKLink } = require("commonsComponents/OKLink");
const { RadioButtonGroup } = require("commonsComponents/radioButtonGroup");
const { RadioButton } = require("commonsComponents/radioButton");
const PreContractualMailInfo = require("components/contactCenter/preContractualMailInfo/preContractualMailInfo");
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
// @actions
const profileActions = require("actions/profile");
const { sendBrokerPreContractualMailV2 } = require("actions/preContractualMailInfo");
// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { recordLinkV2 } = require("utilities/tagging");
// @constants
const SELECTED_VALUES = require("constants/contactCenter/brokerLegalConfirmationSelectedValues");
const {
    ETF_LEGAL_INFORMATION,
    SEND_MAIL_INFORMATION,
    UPDATE_MAIL,
    CLICK_LINK_ACTION,
    CLICK_BUTTON_ACTION,
    AGREEMENT_ACTION,
} = require("constants/tagging");
const { YES, NO } = require("constants/index");
class EtfLegalConfirmation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasResolvedDependencies: false,
            infoFetched: false,
        };
        this.sendMailHandler = this.sendMailHandler.bind(this);
        this.refreshEmailAddressHandler =
            this.refreshEmailAddressHandler.bind(this);
        this.handleYesNoOptionChange = this.handleYesNoOptionChange.bind(this);
        this.handleTagDfiLink = this.handleTagDfiLink.bind(this);
        this.tagSendEmailEvent = this.tagSendEmailEvent.bind(this);
        this.tagRefreshMailEvent = this.tagRefreshMailEvent.bind(this);
    }

    updateState(newState) {
        this.setState(newState);
    }

    tagSendEmailEvent(){
        recordLinkV2({
            categoriaEvento: ETF_LEGAL_INFORMATION,
            accionEvento: CLICK_BUTTON_ACTION,
            etiquetaEvento: SEND_MAIL_INFORMATION,
        })
    }

    tagRefreshMailEvent() {
        recordLinkV2({
            categoriaEvento: ETF_LEGAL_INFORMATION,
            accionEvento: CLICK_BUTTON_ACTION,
            etiquetaEvento: UPDATE_MAIL,
        })
    }

    handleTagDfiLink() {
        recordLinkV2({
            categoriaEvento: ETF_LEGAL_INFORMATION,
            accionEvento: CLICK_LINK_ACTION,
            etiquetaEvento: formatText('etfLegalConfirmation-linkToInvestorData'),
        })
    }

    buildLegalTextDocumentation() {
        const dfiLink = this.props.immETFBuy.get("dfiUrl");
        const linkToInvestorData = (
            <OKLink
                to={dfiLink}
                target="_blank"
                onClick={() => this.handleTagDfiLink()}
            >
                <FormattedText value="etfLegalConfirmation-linkToInvestorData" />
            </OKLink>
        );

        return (
            <div>
                <p>
                    <FormattedText value="etfLegalConfirmation-investmentEtfsInvestorDocumentationTitle" />
                </p>
                <br />
                <p>
                    <FormattedTextWithComponents
                        value="etfLegalConfirmation-investmentEtfsInvestorDocumentationDescription"
                        injectedComponents={[linkToInvestorData]}
                    />
                </p>
            </div>
        );
    }

    buildLegalTextProductDescription() {
        const { immProfile, etfsProduct, productFile } = this.props;
        const clientName = PersonalDataHelper.getFullName(immProfile, false);
        const investmentStrategy = etfsProduct.get('investmentStrategy');
        const productName = productFile.get('companyName');
        const rawRisk = productFile.get('risk');
        let risk;
        if(!!rawRisk) {
            risk = rawRisk.split('of')[0];
        }else {
            risk = '6';
        }
        return (
            <div>
                <p>
                    <FormattedText
                        value="etfLegalConfirmation-investmentEtfsTitleMainFeatures"
                        injectedStrings={[clientName]}
                    />
                </p>
                <ul>
                    <li className="fund-legal-confirmation__fund-feature">
                        <FormattedText
                            value="etfLegalConfirmation-ETFETPDescription1"
                            injectedStrings={[productName]}
                        />
                    </li>
                    <li className="fund-legal-confirmation__fund-feature">
                        <div>
                            <FormattedText value="etfLegalConfirmation-ETFETPDescription2Label" />
                        </div>
                        {investmentStrategy}
                    </li>
                    <li className="fund-legal-confirmation__fund-feature">
                        <FormattedText
                            value="etfLegalConfirmation-ETFETPDescription3"
                            injectedStrings={[risk]}
                        />
                    </li>
                </ul>
            </div>
        );
    }

    buildLegalDisclaimerQuestion() {
        const { immProfile } = this.props;

        const clientName = PersonalDataHelper.getFullName(immProfile, false);

        return (
            <div>
                <p>
                    <FormattedText value="fundLegalConfirmation-legalDisclaimerQuestionFirstStatement" />
                </p>
                <p>
                    <FormattedText
                        value="fundLegalConfirmation-legalDisclaimerQuestionSecondStatement"
                        injectedStrings={[clientName]}
                    />
                </p>
            </div>
        );
    }

    handleYesNoOptionChange(value) {
        this.props.onYesNoOptionChange(value);
        recordLinkV2({
            categoriaEvento: ETF_LEGAL_INFORMATION,
            accionEvento: AGREEMENT_ACTION,
            etiquetaEvento: value === "YES" ? YES : NO,
        });
    }

    buildAnswerOfYesNoQuestion() {
        const { selectedLegalConfirmationValue } = this.props;

        let answerOfYesNoQuestion = null;

        if (selectedLegalConfirmationValue === SELECTED_VALUES.YES) {
            answerOfYesNoQuestion = (
                <BlockInfo extraClass="broker-legal-confirmation__block-info no-print-out">
                    <div>
                        <p>
                            <FormattedText value="fundLegalConfirmation-legalDisclaimerYesAnswerStatement" />
                        </p>
                    </div>
                </BlockInfo>
            );
        } else if (selectedLegalConfirmationValue === SELECTED_VALUES.NO) {
            answerOfYesNoQuestion = (
                <BlockInfo extraClass="broker-legal-confirmation__block-info no-print-out">
                    <div>
                        <p>
                            <FormattedText value="fundLegalConfirmation-legalDisclaimerNoAnswerFirstStatement" />
                        </p>
                        <p>
                            <FormattedText value="fundLegalConfirmation-legalDisclaimerNoAnswerSecondStatement" />
                        </p>
                    </div>
                </BlockInfo>
            );
        }
        return answerOfYesNoQuestion;
    }

    buildYesNoQuestion() {
        const { immPreContractualMail, immProfile } = this.props;

        const refreshEmailAddressError = immProfile.get("error")
            ? immProfile.getIn(["error", "description"], "Error")
            : undefined;

        const optionsDisabled =
            !immPreContractualMail.get("mailSent") ||
            !!refreshEmailAddressError;

        return (
            <React.Fragment>
                <BlockInfo extraClass="broker-legal-confirmation__block-info no-print-out">
                    {this.buildLegalDisclaimerQuestion()}
                    <RadioButtonGroup
                        name="brokerLegalConfirmationYesNo"
                        idPrefix="brokerLegalConfirmationYesNo"
                        selectedValue={
                            this.props.selectedLegalConfirmationValue
                        }
                        onChange={this.handleYesNoOptionChange}
                        className="broker-legal-confirmation__radio-group"
                    >
                        <RadioButton
                            label={formatText(
                                "brokerLegalConfirmation-yesValue"
                            )}
                            value={SELECTED_VALUES.YES}
                            disabled={optionsDisabled}
                            className="broker-legal-confirmation__radio"
                        />
                        <RadioButton
                            label={formatText(
                                "brokerLegalConfirmation-noValue"
                            )}
                            value={SELECTED_VALUES.NO}
                            disabled={optionsDisabled}
                            className="broker-legal-confirmation__radio"
                        />
                    </RadioButtonGroup>
                </BlockInfo>
                {this.buildAnswerOfYesNoQuestion()}
            </React.Fragment>
        );
    }

    buildBrokerLegalConfirmation() {
        return (
            <React.Fragment>
                <BlockInfo extraClass="broker-legal-confirmation__block-info">
                    {this.buildLegalTextProductDescription()}
                </BlockInfo>
                <BlockInfo extraClass="broker-legal-confirmation__block-info">
                    {this.buildLegalTextDocumentation()}
                </BlockInfo>
            </React.Fragment>
        );
    }

    refreshEmailAddressHandler() {
        const { refreshEmailAddress, onYesNoOptionChange } = this.props;
        onYesNoOptionChange && onYesNoOptionChange(SELECTED_VALUES.EMPTY);
        refreshEmailAddress();
    }

    sendMailHandler(params) {
        const { sendMail, onYesNoOptionChange } = this.props;
        onYesNoOptionChange(SELECTED_VALUES.EMPTY);
        sendMail(params);
    }

    render() {
        const etfLegalConfirmationClassNames = classNames(
            "broker-legal-confirmation",
            "content-box"
        );
        const {
            immProfile,
            refreshEmailAddressError,
            immPreContractualMail,
            isin,
            etfsProduct,
        } = this.props;
        const clientEmail = PersonalDataHelper.getEmail(immProfile);
        const clientName = immProfile.get("nombreCliente", "");
        const dfiLink = this.props.immETFBuy.get("dfiUrl");
        const mailParams = {
            clientAlias: clientName,
            email: clientEmail,
            productKID: dfiLink,
            isin,
            isinDescribe: etfsProduct.get("companyName"),
            productType: "ETF",
            orderType: "documentos",
        };

        return (
            <div className={etfLegalConfirmationClassNames}>
                <h1 className="broker-legal-confirmation__title">
                    Información legal
                </h1>
                {this.buildBrokerLegalConfirmation()}
                <div className="broker-legal-confirmation__send-mail no-print-out">
                    <PreContractualMailInfo
                        email={clientEmail}
                        requestProfile={this.refreshEmailAddressHandler}
                        profileError={refreshEmailAddressError}
                        sendEmail={this.sendMailHandler}
                        sendMailParams={mailParams}
                        preContractualMail={immPreContractualMail}
                        showLegalText={false}
                        tagSendEmailEvent={this.tagSendEmailEvent}
                        tagRefreshMailEvent={this.tagRefreshMailEvent}
                    />
                </div>
                {this.buildYesNoQuestion()}
            </div>
        );
    }
}

EtfLegalConfirmation.propTypes = {
    productFile: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    sendMail: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object.isRequired,
    refreshEmailAddressError: PropTypes.string,
    refreshEmailAddress: PropTypes.func,
    selectedLegalConfirmationValue: PropTypes.string.isRequired,
    etfsProduct: PropTypes.object,
    selectedYesNoOption: PropTypes.string.isRequired,
    requestProfile: PropTypes.func.isRequired,
    onYesNoOptionChange: PropTypes.func.isRequired,
    onResolvedDependencies: PropTypes.func,
    immETFBuy: PropTypes.object.isRequired,
    isin: PropTypes.string.isRequired,
    immProfile: PropTypes.object.isRequired,
};

module.exports.constructor = EtfLegalConfirmation;
module.exports.EtfLegalConfirmation = connect(
    (state) => ({
        etfsProduct: state.brokerETFsProduct,
        productFile: state.brokerProductFile,
        immETFBuy: state.brokerETFBuy,
        immProfile: state.profile,
        immPreContractualMail: state.preContractualMail,
        immBrokerFundLegalDocument: state.brokerFundLegalDocument,
    }),
    {
        refreshEmailAddress: profileActions.requestProfile,
        sendMail: sendBrokerPreContractualMailV2,
    }
)(EtfLegalConfirmation);
